module.exports = __webpack_public_path__ + "static/media/Lunugamvehera.b1019458.png";